module.exports = __webpack_public_path__ + "img/gywm-1.8d2f55ca.png";